(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["happyMndy-how-to-use"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  new Swiper(".how-to-use-swiper", {
    slidesPerView: 1.2,
    spaceBetween: 14,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      768: { slidesPerView: 3, spaceBetween: 30 },
    },
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["news-blog"] && !Shopify.designMode) return;
  try {
    
const desktopSwiper = new Swiper('.latest-news-swiper', {
  slidesPerView: 3.4,
  spaceBetween: 20,
  speed:1000,
  navigation: {
    nextEl: '.cs_slide-btn .cstm-button-next',
    prevEl: '.cs_slide-btn .cstm-button-prev',
  },
  breakpoints: {
    320: { slidesPerView: 1.2, spaceBetween: 20 },
    768: { slidesPerView: 2 },
    1024: { slidesPerView: 3.4 },
  }
});

const mobileSwiper = new Swiper('.latest-news-swiper', {
  slidesPerView: 1.2,
  spaceBetween: 20,
  loop: true,
  speed:1000,
  navigation: {
    nextEl: '.cs_slide-btn-mobl .cstm-button-next',
    prevEl: '.cs_slide-btn-mobl .cstm-button-prev',
  },
  breakpoints: {
    320: { slidesPerView: 1.2, spaceBetween: 20 },
    768: { slidesPerView: 2 },
    1024: { slidesPerView: 3 },
  }
});

  } catch(e) { console.error(e); }
})();
})();
